var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilledStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0741 16.3182L5.43741 19.2816L6.51392 13.005L1.95373 8.55994L8.25576 7.6442L11.0741 1.93359L13.8925 7.6442L20.1945 8.55994L15.6343 13.005L16.7108 19.2816L11.0741 16.3182Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.958974
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilledStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FilledStar.f1c3742c42f55b583b8e5ec23ca6b718.svg";